import React from "react";
import Nav from "@/components/solanova/Nav";
import Hero from "@/components/solanova/Hero";
import About from "@/components/solanova/About";
import Services from "@/components/solanova/Services";
import FoerderCheck from "@/components/solanova/FoerderCheck";
import LeadFunnel from "@/components/solanova/LeadFunnel";
import Faq from "@/components/solanova/Faq";
import Contact from "@/components/solanova/Contact";
import Footer from "@/components/solanova/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[var(--sol-bg)] text-white overflow-x-hidden">
      <Nav />
      <Hero />
      <About />
      <Services />
      <FoerderCheck />
      <LeadFunnel />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
}
